import "./ResponsiveContainer.css";

const ResponsiveContainer = ({ children, className="" }) => {
    return (
        <div className={`responsive-container ${className || ""}`}>
            {children}
        </div>
    );
};

export default ResponsiveContainer;
